import { h } from 'preact'
import TopicListView from '../topic-list-view/TopicListView'
import { TopicInfo } from '../topic-list-view/TopicListItemView'

export interface RecentlyActiveTopicsProps {
  tab: string
  requestUrl: string
  query: {}
  attachmentCdn: string
  topics: TopicInfo[]
}

const RecentlyActiveTopics = (props: RecentlyActiveTopicsProps) => (
  <div className='box widget box__content qa-widget-recent-topics topic-list-view'>
    <TopicListView {...props} />
  </div>
)

export default RecentlyActiveTopics
